/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerEnquiryResponse as ModelsCustomerCustomerEnquiryResponse } from '../../models/Models/Customer/customer-enquiry-response';

export interface V4CustomersMeOffersOfferIdPatch$Json$Params {
  offerId: number;
}

export function v4CustomersMeOffersOfferIdPatch$Json(http: HttpClient, rootUrl: string, params: V4CustomersMeOffersOfferIdPatch$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeOffersOfferIdPatch$Json.PATH, 'patch');
  if (params) {
    rb.path('offerId', params.offerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>;
    })
  );
}

v4CustomersMeOffersOfferIdPatch$Json.PATH = '/v4/customers/me/offers/{offerId}';
